export const formatHourDefault = (hour: string | number): string => hour.toString().padStart(4, '0').replace(/\d{2}(?=.)/g, '$&:');
